import Api from "./Api";
import { clienteApiConfig } from "./config";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import {
  DadosClienteModel,
} from "@/models/solicitacoes";


class ClienteApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }


  obterDadosCliente(idCliente: number): Promise<DadosClienteModel> {
    return this.get<DadosClienteModel>(`/associados/${idCliente}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter os detalhes do cliente");
      });
  }

}

export const clienteApi = new ClienteApi(
  clienteApiConfig
);